export default __webpack_public_path__ + "static/media/V124_SOV.a98f53e3.pdf";